import React from 'react';
import { TextInput } from '@carbon/react';

const IngestSettings: React.FC = () => (
  <div className="settings-page__form-grid">
    <TextInput id="ingest-max-concurrent-uploads" labelText="Max concurrent uploads" placeholder="4" />
    <TextInput id="ingest-max-upload-size-gb" labelText="Max upload size (GB)" placeholder="100" />
    <TextInput id="ingest-ftp-retention" labelText="FTP folder retention (days)" placeholder="7" />
  </div>
);

export default IngestSettings;
